import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { createRef } from "preact";
import { useState } from "preact/hooks";
import { CurrentTask } from "./CurrentTask";
import { useAppSelector } from "./hooks";
import { selectIsComplete } from "./tasksSlice";
export const Message = (props) => {
    const textArea = createRef();
    const form = createRef();
    const [didSend, setDidSend] = useState(false);
    const send = (ev) => {
        ev.preventDefault();
        props.onReply(textArea.current.value);
        setDidSend(true);
    };
    return (_jsxs("li", { className: "message-item card flow", "data-complete": props.replied, children: [_jsx("h2", { children: props.subject }), _jsx("div", { className: "msg-details", children: _jsxs("span", { children: ["From ", props.from] }) }), _jsx("div", { children: props.content }), _jsx("hr", {}), _jsxs("form", { ref: form, onSubmit: send, children: [_jsx("div", { children: _jsx("textarea", { ref: textArea, onKeyPress: (ev) => {
                                if (ev.ctrlKey && ev.key === "Enter") {
                                    form.current?.requestSubmit();
                                    ev.preventDefault();
                                }
                            }, placeholder: "Reply..." }) }), _jsx("input", { type: "submit", value: "Send Reply" }), didSend ? _jsx("p", { children: "Sent!" }) : null] })] }));
};
const MessageWrapper = (props) => {
    const replied = useAppSelector((s) => selectIsComplete(s, props.id));
    return _jsx(Message, { replied: replied, ...props });
};
export const Messages = (props) => {
    const messageEls = props.messages.map((msg) => {
        return (_jsx(MessageWrapper, { ...msg, onReply: (text) => props.onReply(msg.id, text) }));
    });
    return (_jsxs("article", { className: "messages-main", children: [_jsx("h1", { children: "Messages" }), _jsx(CurrentTask, {}), _jsxs("ul", { role: "list", className: "messages flow", children: [...messageEls] })] }));
};
